import * as React from 'react';
import { css } from 'emotion';

const rightColumnRules = css({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'space-between',
  overflow: 'hidden'
});

const actionRowRules = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '20px 15px'
});

const buttonRules = (shouldDisableHoverState: boolean) =>
  css(
    {
      WebkitAppearance: 'none',
      border: 'none',
      fontSize: 14,
      letterSpacing: '.6px',
      fontWeight: 600,
      margin: '0 5px',
      padding: 10,
      backgroundColor: 'white',
      transition: 'background-color .4s cubic-bezier(.25, .8, .25, 1)',
      borderRadius: 3,
      minWidth: 80,
      cursor: 'pointer',
      outline: 'none'
    },
    !shouldDisableHoverState && {
      ':hover': {
        backgroundColor: 'rgba(158, 158, 158, .2)'
      }
    }
  );

interface Props {
  closePortal: (e: any) => any;
  handleSubmit: (e: any) => any;
  render: () => any;
}

const RightPane: React.SFC<Props> = ({ closePortal, render, handleSubmit }) => {
  const shouldDisableHoverState = window && window.matchMedia('(max-width: 760px)').matches;
  const buttonStyles = buttonRules(shouldDisableHoverState);

  return (
    <div className={rightColumnRules}>
      {render()}

      <div className={actionRowRules}>
        <button className={buttonStyles} onClick={closePortal}>
          CANCEL
        </button>
        <button className={buttonStyles} onClick={handleSubmit}>
          OK
        </button>
      </div>
    </div>
  );
};

export { RightPane };
